import { render, staticRenderFns } from "./CartSum.vue?vue&type=template&id=0c193b3b&scoped=true"
import script from "./CartSum.vue?vue&type=script&lang=js"
export * from "./CartSum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c193b3b",
  null
  
)

export default component.exports